import React from "react";

import { useSectionList } from "src/modules/basic-health/dashboard";
import { useHeaderValues } from "src/modules/basic-health/header";
import { Report as BareReport } from "src/modules/shared/dashboard";

export const Report: React.FunctionComponent = () => {
	const header = useHeaderValues();
	const sections = useSectionList();
	return <BareReport header={header} sections={sections} />;
};
